import { useState } from 'react'
import { NoImageIcon } from 'components/icons'

interface ProductImageProps {
  src: string | null
  alt?: string
  fallbackText?: string
  className?: string
  size?: number
  showFallbackIcon?: boolean
}

const ProductImage = ({
  src,
  alt = 'Product image',
  fallbackText = 'No Image Available',
  className = '',
  size,
  showFallbackIcon = false,
}: ProductImageProps) => {
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const showFallback = !src || isError

  return (
    <div
      style={size ? { height: size, width: size } : undefined}
      className={`relative flex items-center justify-center overflow-hidden rounded-lg border bg-gray-100 ${
        size ? '' : 'h-40 w-40'
      } ${className}`}
    >
      {isLoading && !showFallback && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/70 text-sm text-gray-500">
          Loading...
        </div>
      )}

      {!showFallback && (
        <img
          src={src}
          alt={alt}
          className="h-full w-full object-contain"
          onLoad={() => setIsLoading(false)}
          onError={() => {
            setIsError(true)
            setIsLoading(false)
          }}
        />
      )}

      {showFallback && showFallbackIcon && (
        <div className="flex flex-col items-center gap-1.5 p-3 text-gray-300">
          <span className="h-7 w-7">
            <NoImageIcon />
          </span>
          {fallbackText && (
            <span className="text-center text-[11px] font-medium text-gray-400">
              {fallbackText}
            </span>
          )}
        </div>
      )}

      {showFallback && !showFallbackIcon && (
        <span className="p-3 text-center text-xs text-gray-400">
          {fallbackText}
        </span>
      )}
    </div>
  )
}

export default ProductImage
